module.exports = __webpack_public_path__ + "img/architecture-diagram.c11182d9.png";